import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export class ErrorHandler {
    static showToast(message, variant = 'danger') {
        // Bootstrap Toast HTML 동적 생성
        const toastHTML = `
      <div class="toast-container position-fixed top-0 end-0 p-3">
        <div class="toast align-items-center text-bg-${variant} border-0" role="alert" aria-live="assertive" aria-atomic="true">
          <div class="d-flex">
            <div class="toast-body">
              ${message}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
          </div>
        </div>
      </div>
    `

        // 기존 toast-container가 있다면 제거
        const existingContainer = document.querySelector('.toast-container')
        if (existingContainer) {
            existingContainer.remove()
        }

        // 새로운 toast 추가
        document.body.insertAdjacentHTML('beforeend', toastHTML)

        // Bootstrap Toast 초기화 및 표시
        const toastElement = document.querySelector('.toast')
        const toast = new bootstrap.Toast(toastElement, {
            animation: true,
            autohide: true,
            delay: 3000
        })
        toast.show()
    }

    static showErrorModal(title, message) {
        const modalHTML = `
  <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-describedby="errorModalDescription">
    <div class="modal-dialog">
      <div class="modal-content shadow-lg">
        <div class="modal-header bg-danger text-white rounded-top-2">
          <h5 class="modal-title" id="errorModalLabel">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>${title}
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" id="errorModalDescription">
          ${message}
        </div>
        <div class="modal-footer border-0">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>
        </div>
      </div>
    </div>
  </div>
`;

        // 기존 modal 제거
        const existingModal = document.getElementById('errorModal');
        if (existingModal) {
            existingModal.remove();
        }

        // 새 modal 추가
        document.body.insertAdjacentHTML('beforeend', modalHTML);

        // Bootstrap Modal 초기화
        const modalElement = document.getElementById('errorModal');
        const modal = new bootstrap.Modal(modalElement);

        // 모달이 열리기 전의 포커스 요소 저장
        const previousActiveElement = document.activeElement;

        // 모달 열릴 때 처리
        modalElement.addEventListener('show.bs.modal', () => {
            // 모달을 제외한 다른 모든 요소에 inert 속성 추가
            document.querySelectorAll('body > *:not(#errorModal)').forEach(element => {
                element.setAttribute('inert', '');
            });
        });

        // 모달 닫히기 시작할 때 처리
        modalElement.addEventListener('hide.bs.modal', () => {
            // 포커스를 모달 외부로 이동하기 전에 모달 내부 버튼의 포커스 제거
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }

            // inert 속성 제거
            document.querySelectorAll('[inert]').forEach(element => {
                element.removeAttribute('inert');
            });

            // 이전 포커스 요소로 포커스 반환
            if (previousActiveElement) {
                setTimeout(() => {
                    previousActiveElement.focus();
                }, 0);
            }
        });

        // 모달이 완전히 닫힌 후 처리
        modalElement.addEventListener('hidden.bs.modal', () => {
            modalElement.remove();
        });

        modal.show();
    }
}

// axios 인터셉터에서 사용할 에러 처리
export const errorMessages = {
    400: '잘못된 요청입니다.',
    401: '인증이 필요합니다.',
    403: '접근 권한이 없습니다.',
    404: '요청한 리소스를 찾을 수 없습니다.',
    500: '서버 에러가 발생했습니다.',
    502: '게이트웨이 에러가 발생했습니다.',
    503: '서비스를 사용할 수 없습니다.',
    default: '알 수 없는 에러가 발생했습니다.'
}
